import React from "react";
import { Link } from "react-router-dom";
import defaultImg from "../images/room-1.jpeg";
// import styled from "styled-components";
// import styles from "./Room.module.css";
// import "./Room.css";
import PropTypes from "prop-types";

// const RoomArticle = styled.article`
//   box-shadow: 2px 5px 3px 0px rgba(0, 0, 0, 0.5);
//   transition: all 0.3s linear;
//   &:hover {
//     box-shadow: 4px 10px 5px 0px rgba(0, 0, 0, 0.5);
//   }
//   p {
//     background: #cfcfcf;
//     text-transform: capitalize;
//     padding: 0.5rem 0;
//     text-align: center;
//     font-weight: 700;
//     letter-spacing: 3px;
//   }
// `;
// const ImageContainer = styled.div`
//   position: relative;
//   img {
//     width: 100%;
//     display: block;
//     transition: all 0.3s linear;
//     &:hover {
//       opacity: 0.3;
//     }
//   }
//   &:hover {
//     background: rgba(0, 0, 0, 0.8);
//     opacity: 0;
//     transform: translate(-50%, -50%) scale(1);
//   }
// `;
// const PriceTop = styled.div`
//   position: absolute;
//   opacity: 0;
//   top: 0;
//   left: 0;
//   background: rgba(0, 0, 0, 0.8);
//   color: #fff;
//   padding: 0.3rem 0.6rem 0.5rem;
//   border-bottom-right-radius: 1rem;
//   font-size: 0.5rem;
//   text-align: center;
//   transition: all 0.3s linear;
//   h6 {
//     margin-bottom: 0;
//     font-size: 0.9rem;
//     font-weight: 300;
//     letter-spacing: 3px;
//   }
// `;

export default function Room({ room }) {
  //console.log(room);
  const { name, slug, images, price } = room;
  return (
    <article className="room">
      <div className="img-container">
        <img src={images[0] || defaultImg} alt="single room" />
        <div className="price-top">
          <h6>${price}</h6>
          <p>per night</p>
        </div>
        <Link to={`/rooms/${slug}`} className="btn-primary room-link">
          features
        </Link>
      </div>
      <p className="room-info">{name}</p>
    </article>
  );
}

Room.propTypes = {
  room: PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    images: PropTypes.arrayOf(PropTypes.string).isRequired,
    price: PropTypes.number.isRequired,
  }),
};
